<template>
   <el-container class="wrapper">
    <el-header><HeaderDom></HeaderDom></el-header>
     <el-container>

      <el-aside width="100%">
        <!-- <MenuDom></MenuDom> -->
        <AsideDom width="240px"></AsideDom>
      </el-aside>
      <!-- 首页菜单不伸缩，其他功能菜单伸缩 by li.xue 2019/7/11
      <el-main class="content-box" :class="{'content-collapse':collapse}">
      -->
      <tip id="hometip" style="width: 300px;height: 200px;" v-show="searchVal.showView"  :json="json" @closeView="closeView"></tip>

      <el-main class="content-box" :class="collapseStyle">
          <div class="content">
            <Breadcrumb></Breadcrumb>
            <transition name="move" mode="out-in">
              
                <router-view class="content-in"></router-view>
            </transition>
          </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
//引入Header Component
import HeaderDom from '@/views/common/layout/HeadDom'
//引入一级Menu Component
import MenuDom from '@/views/common/layout/MenuDom'
//引入Aside Component
import AsideDom from '@/views/common/layout/AsideDom'
//引入面包屑Breadcrumb
import Breadcrumb from '@/components/breadcrumb'
import bus from '../../common/js/bus';

import tip from '@/components/loginTip'
import { mapMutations } from "vuex";
export default {
  data(){
    return {
      collapse: false,
      index:0,
      json: {
        url: 'http://36.129.10.24:8843/#/notice/detail?xwid=C4786C53DD20EC1DE05011AC02004715',
        left: 100,
        top: 400,
        directionX: 1,
        directionY: 1,
        distance: null,
        interval: null,
        target: "_blank",
        zIndex: null,
        width: null,
        height: null,
        noHoverPause: null, //鼠标经过时不停止，为true时不停止
        cursor: null,
        imgurl: "../../../static/images/login/pc.png",


      },
	  searchVal: {
	  	showView: false,
	  },
    }
  },
  components: {
    HeaderDom,
    MenuDom,
    AsideDom,
    Breadcrumb,
	tip,
  },
  computed: {
    routes() {
      return this.$router.options.routes;
    },
    collapseStyle() {
      /**首页伸缩 by li.xue 2019/12/25 */
      /**
      if(this.$route.path == '/home'){
        return "content-collapse1";
      }else{
        if(this.collapse){
          return "content-collapse";
        }else{
          return "content-collapse2";
        }
      }
      */
      if(this.collapse){
        return "content-collapse";
      }else{
        return "content-collapse2";
      }
    }
  },
  watch:{
    $route(to,from){
      if(to.path == '/home'){
        this.change(true)
        // this.searchVal.showView = false
        if(this.CONSTANT.currentUser.usertype != null && this.CONSTANT.currentUser.usertype != "APP" && (this.CONSTANT.currentUser.deptid == '90'||this.CONSTANT.currentUser.deptid == '80')){
          this.searchVal.showView = true
        }


      }else{
        this.change(false)
      }

    },
    '$route.path': function(newVal, oldVal) {
    		if (newVal != "/home") {
    			this.searchVal.showView = false
    		} else {
        if(this.CONSTANT.currentUser.usertype != null  && this.CONSTANT.currentUser.usertype != "APP" &&  (this.CONSTANT.currentUser.deptid == '90'||this.CONSTANT.currentUser.deptid == '80')){

          this.searchVal.showView = true
        }
         // this.searchVal.showView = true
    		}

        // console.log(this.searchVal.showView+"~~~~~~~~~"+newVal)
    	}
  },
  methods: {
    ...mapMutations(["SET_ISHOME"]),
    closeTip:function(){
      //删除填报说明飘窗
      var idObject = document.getElementById('hometip');
       if (idObject != null){
         idObject.parentNode.removeChild(idObject);
       }
    },
    change(val){
      this.$store.commit('SET_ISHOME',val);
      if(this.CONSTANT.currentUser.usertype != null  && this.CONSTANT.currentUser.usertype != "APP" && (this.CONSTANT.currentUser.deptid == '90'||this.CONSTANT.currentUser.deptid == '80')){
        this.searchVal.showView = val
      }
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    closeView: function() {
    	this.searchVal.showView = false;
    },
  },
  created(){
      bus.$on('collapse', msg => {
          this.collapse = msg;
      })

	  if(this.searchVal.showView == false){
     if(this.CONSTANT.currentUser.usertype != null  && this.CONSTANT.currentUser.usertype != "APP" && (this.CONSTANT.currentUser.deptid == '90'||this.CONSTANT.currentUser.deptid == '80')){
       this.searchVal.showView = true
     }
	  }
  }
};
</script>
<style scoped>
.el-header,
.el-footer {
  background: url(../../../static/images/home/pic_head_red.png) no-repeat;
  background-color: #961617;
  color: #333;
  text-align: center;
  line-height: 50px;
}
.el-header{
  padding:0;
  height:60px !important;
}
/* .aside {
  width: 240px !important;
  height: 600px;
  background-color: rgb(70, 49, 50);
} */
.el-main {
  padding: 5px;
  font-size: 14px;
}
.content-box {
    position: absolute;
    /* left: 240px; */
    right: 0;
    top: 60px;
    bottom: 0;
    padding-bottom: 10px;
    -webkit-transition: left .3s ease-in-out;
    transition: left .3s ease-in-out;
    background: #f8f8f8;
    display: flex;
    flex-direction: column;
}

.content {
    display: flex;
    flex: 1;
    flex-direction: column;
    box-sizing: border-box;
    width: auto;
    height: 100%;
    padding: 2px 7px 0 7px;
    overflow-y: hidden;
}
.content-in {
    overflow-y: auto;
    overflow-x: hidden;
}

.content-collapse {
    left: 65px;
}
.content-collapse1 {
    left: 0px;
}
.content-collapse2 {
    left: 240px;
}

.container {
    padding: 30px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
}

.wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/common/Index.vue